// https://keenthemes.com/metronic/preview/react/demo2/google-material/inputs/selects
import React, {useState, useEffect, memo} from "react";
import {Dropdown} from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

export const CustomDropdown = memo(
    ({
        className = "",
        placeholder = "",
        variant = "",
        multipleOptions,
        optionsMaxWidth,
        options = [],
        selected = [],
        setSelected,
        page = "",
        fitContent = false,
        noMargins = false,
        buttonClass = "",
    }) => {
        const [isLoading, setIsLoading] = useState(true);
        useEffect(() => {
            if (options && options.length) {
                setIsLoading(false);
            }

            return () => setIsLoading(true);
        }, [options, selected]);

        const handleSelect = inputValue => {
            const isAlreadySelected = selected.indexOf(inputValue) !== -1;

            if (!isAlreadySelected) {
                if (multipleOptions) {
                    setSelected([...selected, inputValue]);
                } else {
                    setSelected([inputValue]);
                }
            }
        };

        const placeholderOrFirst = () => {
            if (selected && selected[0]) {
                if (typeof selected[0] === "string") {
                    return selected.map(item => item).join(", ") || placeholder || "Choose items";
                } else if (typeof selected[0] === "object") {
                    if (selected[0].name) {
                        const defaultName = selected.map(item => item.name).join(", ") || placeholder || "Choose items";
                        return defaultName;
                    } else return placeholder || "Choose items";
                }
            }
        };

        const getContent = () => {
            if (options && options[0]) {
                if (typeof options[0] === "string") {
                    return options.map((option, idx) => (
                        <Dropdown.Item
                            key={idx}
                            onClick={() => handleSelect(option)}
                            active={selected && selected[0] && selected[0] === option}
                        >
                            {option}
                        </Dropdown.Item>
                    ));
                } else if (typeof options[0] === "object") {
                    return options.map((option, i) => {
                        if (option.suboptions) {
                            return (
                                <div className="d-flex flex-column" key={i + " group"}>
                                    <Dropdown.Header className="font-weight-bolder font-size-base">
                                        {option.name}
                                    </Dropdown.Header>
                                    {option.suboptions.map((suboption, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            className="pl-7"
                                            onClick={() => handleSelect(suboption)}
                                            active={
                                                selected &&
                                                selected[0] &&
                                                ((selected[0].key &&
                                                    suboption.key &&
                                                    selected[0].key === suboption.key) ||
                                                    (selected[0].id && suboption.id && selected[0].id === suboption.id))
                                            }
                                            disabled={suboption.disabled}
                                        >
                                            {suboption.name}
                                        </Dropdown.Item>
                                    ))}
                                </div>
                            );
                        } else {
                            return (
                                <Dropdown.Item
                                    key={i}
                                    onClick={() => handleSelect(option)}
                                    active={
                                        selected &&
                                        selected[0] &&
                                        ((selected[0].key && option.key && selected[0].key === option.key) ||
                                            (selected[0].id && option.id && selected[0].id === option.id))
                                    }
                                    disabled={option.disabled}
                                >
                                    {option.name}
                                </Dropdown.Item>
                            );
                        }
                    });
                }
            }
        };

        if (!options || !options[0] || !selected || !selected[0])
            return (
                <button
                    className={`btn btn-${variant} h-40px py-2 px-4 overflow-hidden text-center ${buttonClass} w-100px pointer-events-none m-0 my-4`}
                >
                    {!isLoading ? placeholder || "Choose item" : <CircularProgress className="w-15px h-15px mx-auto" />}
                </button>
            );
        else
            return (
                <Dropdown
                    className={className || "pr-6 d-flex"}
                    style={{
                        margin: noMargins ? "" : "1rem 0",
                        width: fitContent ? "fit-content" : "",
                    }}
                >
                    <Dropdown.Toggle variant={variant} className={`py-2 px-4 overflow-hidden w-100 ${buttonClass}`}>
                        <span style={{minHeight: "17.6px"}}>
                            {placeholderOrFirst()}
                            {<KeyboardArrowDownIcon />}
                        </span>
                    </Dropdown.Toggle>
                    <div className={`d-flex z-index-20 position-${optionsMaxWidth ? "absolute w-100" : "fixed"}`}>
                        <Dropdown.Menu className={`d-flex flex-column w-fit-content ${optionsMaxWidth ? "w-100" : ""}`}>
                            {getContent()}
                            {page === "review" ? (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                        onClick={() =>
                                            handleSelect({
                                                key: "speakers",
                                                name: "Speakers",
                                                disabled: 0,
                                            })
                                        }
                                        active={
                                            selected && selected[0]
                                                ? selected.find(x => x.name === "Speakers")
                                                : undefined
                                        }
                                    >
                                        Speakers
                                    </Dropdown.Item>
                                </>
                            ) : null}
                        </Dropdown.Menu>
                    </div>
                </Dropdown>
            );
    }
);
